import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { DrawerRef, DrawerService } from "mis-crystal-design-system/drawer";
import moment, { parseZone } from 'moment';
import { BaseFormGroup } from 'src/app/shared/form-input-components/base-form-group';
import { CommonService } from 'src/app/shared/services/common.service';
import { AuthService } from '../../../shared/services/auth.service';
import { UtilService } from '../../../shared/services/util.service';
import { MyBookingsService } from '../my-bookings.service';
import { PaymentCartComponent } from '../payment-cart/payment-cart.component';
import { BookingDetailsSidebarComponent } from './booking-details-sidebar/booking-details-sidebar.component';
@Component({
  selector: 'app-my-bookings-card',
  templateUrl: './my-bookings-card.component.html',
  styleUrls: ['./my-bookings-card.component.scss']
})
export class MyBookingsCardComponent extends BaseFormGroup implements OnInit, OnChanges, OnDestroy {

  @Input() bookings: any;
  // @Input() booking: any;
  @Input() showBookingDetails: any;
  @Input() bookingDetails: any;
  @Input() cancelCutOffDetails: any;
  @Input() editCutOffDetails: any;
  @Input() miscelleneousConfig;
  @Input() tabValue;
  @Input() currentPageSize;
  @Input() pageIndexNew;
  @Input() totalNoOfRows;
  @Input() upcomingOnly;
  @Input() bookingLabel;
  @Input() paginationId;

  @Output() showBookingsCallback = new EventEmitter();
  @Output() showRequestDetailsCallback = new EventEmitter();
  @Output() cancelBookingCallback = new EventEmitter();
  @Output() showHistoryCallback = new EventEmitter();
  @Output() showPaginationCallback = new EventEmitter();
  @Output() refreshBookings: EventEmitter<any> = new EventEmitter();

  public bookingSource: any;
  public bookingDestination: any;
  public noOfStops: any;
  public ridersList: any;
  public canCancel = false;
  public showCancelBookingError = false;
  public config: any = {};
  // public disableAllActions = false;
  public canEdit = false;
  public showEditBookingError = false;
  public isTrackingVisible: boolean;
  public startTime: any;
  public showSuccessMessage = false;
  public message: string;
  public showPaymentFailed = false;
  public paymentFailedMessage: string;
  public paymentAmount: any;
  bookingConfigForPage;
  hasDimmBack = false;
  singleReg: any = {};
  drawerRef: DrawerRef;
  // upcomingOnly: boolean = false;
  filteredBookings: any = [];
  upcomingBookings: any = [];
  pastBookings: any = [];
  todaysBookings: any;
  showSinglePaymentPopup: boolean;
  showBulkPaymentPopup: boolean;
  paymentResponse: any;
  paymentAmt: any;
  totalAmt: any;
  showSnackbar: boolean;
  razorpay_payment_id = '';
  marshalAssigned = false;
  managerStatus: any = {};
  otherState: any = null;
  constructor(private router: Router, private utilService: UtilService,
              private commonService: CommonService, private authService: AuthService,
              private changeDetectorRef: ChangeDetectorRef,
              private drawerSvc: DrawerService,
              private myBookingService: MyBookingsService,
              private datePipe: DatePipe) { super(); }

  ngOnChanges(changes: SimpleChanges): void {
  
    if (changes.bookings && changes.bookings.currentValue) {
      this.bookings = changes.bookings.currentValue;
      const date = moment();
      if (this.bookingLabel === 'Upcoming Booking' && !this.upcomingOnly && this.tabValue === 'upcoming') {
        this.upcomingBookings = this.bookings.filter((book) => {
          const startTime = moment(this.getMiliseconds(book));
          if(book.bookingStatus === 'CANCELLED' && (date.format('DD-MM-YYYY') === startTime.format('DD-MM-YYYY') && startTime.valueOf() < date.valueOf())){
            return false;
          } else if(book.tripStatus !== 'TRIP_COMPLETED' && book.tripStatus !== 'DUTY_COMPLETED'){
            return true
          }else{
            return false;
          }
          // if (this.getMiliseconds(book) >= date.getTime() && book.tripStatus !== 'TRIP_COMPLETED' && book.tripStatus !== 'DUTY_COMPLETED')
          // {
          //     return true;
          // }
        });
        this.todaysBookings = this.upcomingBookings[0];
        this.filteredBookings = this.upcomingBookings.slice(1, 5);
        this.checkManagerStatus(this.todaysBookings.managerStatus);
        this.checkOtherState(this.todaysBookings);
       
    }else if (this.tabValue === 'past')
    {
      this.pastBookings = this.bookings.filter((book) => {
        const startTime = moment(this.getMiliseconds(book));
        if (startTime.format("DD-MM-YYYY") == date.format("DD-MM-YYYY") && (book.tripStatus === 'TRIP_COMPLETED' || (book.bookingStatus === 'CANCELLED' && startTime.valueOf() < date.valueOf()))) {
          return true;
      } else if (startTime.format("DD-MM-YYYY") == date.format("DD-MM-YYYY") && book.tripStatus != 'TRIP_COMPLETED') {
          return false;
      } else {
          return true;
      }
        
    //     if ((this.getMiliseconds(book) < date.getTime() && book.bookingStatus === 'CANCELLED') || book.tripStatus === 'TRIP_COMPLETED' )
    //  {
    //   return true;
    //  }
      });
      this.filteredBookings = this.pastBookings;
          }  else {
      this.upcomingBookings = this.bookings.filter((book) => {
        const startTime = moment(this.getMiliseconds(book));
        if(book.bookingStatus === 'CANCELLED' && (date.format('DD-MM-YYYY') === startTime.format('DD-MM-YYYY') && startTime.valueOf() < date.valueOf())){
          return false;
        } else if(book.tripStatus !== 'TRIP_COMPLETED' && book.tripStatus !== 'DUTY_COMPLETED'){
          return true
        }else{
          return false;
        }
      });
      this.filteredBookings = this.upcomingBookings.slice(5);
    }
    }
    if (changes.currentPageSize && changes.currentPageSize.currentValue) {
      this.currentPageSize = changes.currentPageSize.currentValue;
    }
    if (changes.pageIndexNew && changes.pageIndexNew.currentValue) {
      this.pageIndexNew = changes.pageIndexNew.currentValue;
    }
    if (changes.totalNoOfRows && changes.totalNoOfRows.currentValue) {
      this.totalNoOfRows = changes.totalNoOfRows.currentValue;
    }
  }

  ngOnInit() {
       const date =moment();
    if (this.bookingLabel === 'Upcoming Booking' && !this.upcomingOnly && this.tabValue === 'upcoming') {
      this.upcomingBookings = this.bookings.filter((book) => {
        const startTime = moment(this.getMiliseconds(book));
          if(book.bookingStatus === 'CANCELLED' && (date.format('DD-MM-YYYY') === startTime.format('DD-MM-YYYY') && startTime.valueOf() < date.valueOf())){
            return false;
          } else if(book.tripStatus !== 'TRIP_COMPLETED' && book.tripStatus !== 'DUTY_COMPLETED'){
            return true
          }else{
            return false;
          }
        // if (this.getMiliseconds(book) >= date.getTime() && book.tripStatus !== 'TRIP_COMPLETED' && book.tripStatus !== 'DUTY_COMPLETED')
        // {
        //     return true;
        // }
      });
      this.todaysBookings = this.upcomingBookings[0];
      this.filteredBookings = this.upcomingBookings.slice(1, 5);
      this.checkManagerStatus(this.todaysBookings.managerStatus);
      this.checkOtherState(this.todaysBookings);
    }
    else if (this.tabValue === 'past')
    {
      this.pastBookings = this.bookings.filter((book) => {
        const startTime = moment(this.getMiliseconds(book));
        if (startTime.format("DD-MM-YYYY") == date.format("DD-MM-YYYY") && (book.tripStatus === 'TRIP_COMPLETED' || (book.bookingStatus === 'CANCELLED' && startTime.valueOf() < date.valueOf()))) {
          return true;
      } else if (startTime.format("DD-MM-YYYY") == date.format("DD-MM-YYYY") && book.tripStatus != 'TRIP_COMPLETED') {
          return false;
      } else {
          return true;
      }
    //     if ((this.getMiliseconds(book) < date.getTime() && book.bookingStatus === 'CANCELLED') || book.tripStatus === 'TRIP_COMPLETED' )
    //  {
    //   return true;
    //  }
      });
      this.filteredBookings = this.pastBookings;
    } else {
      this.upcomingBookings = this.bookings.filter((book) => {
        const startTime = moment(this.getMiliseconds(book));
        if(book.bookingStatus === 'CANCELLED' && (date.format('DD-MM-YYYY') === startTime.format('DD-MM-YYYY') && startTime.valueOf() < date.valueOf())){
          return false;
        } else if(book.tripStatus !== 'TRIP_COMPLETED' && book.tripStatus !== 'DUTY_COMPLETED'){
          return true
        }else{
          return false;
        }
      });
      this.filteredBookings = this.upcomingBookings.slice(5);
    }

    this.noOfStops = this.bookings[0].stops?.length;
    const ridersList = [];
    if (this.noOfStops) {
      for (const stop of this.bookings[0].stops) {
        if (Number(stop.priorityOrder) === 1) {
          this.bookingSource = stop;
        }
        if (Number(stop.priorityOrder) === this.noOfStops && this.noOfStops !== 1) {
          this.bookingDestination = stop;
        }
        for (const rider of stop.riders) {
          if (!ridersList.length) {
            ridersList.push(rider);
          } else {
            let riderExists = false;
            for (const newRider of ridersList) {
              if (newRider.personId === rider.personId) {
                riderExists = true;
                break;
              }
            }
            if (!riderExists) {
              ridersList.push(rider);
            }
          }
        }
      }
    }

    this.ridersList = ridersList;
    this.startTime = this.getBookingTime(this.bookings[0]);
    if (this.bookings[0].bookingAmount) {
      this.paymentAmount = Number(this.bookings[0].bookingAmount) / 100;
      this.paymentAmount = Number(this.paymentAmount).toFixed(2);
    }
    // this.checkIfBookingCancelled();
    this.setupConfig();
    this.myBookingService.singlePaymentPopup.subscribe((res) => {
      this.showSinglePaymentPopup = res;
      this.changeDetectorRef.detectChanges();
    });
    this.myBookingService.bulkPaymentPopup.subscribe((res) => {
      this.showBulkPaymentPopup = res;
      this.changeDetectorRef.detectChanges();
    });
    this.myBookingService.paymentStatus.subscribe((res) => {
      this.paymentResponse = res;
      this.changeDetectorRef.detectChanges();
    });

    this.myBookingService.paymentAmount.subscribe((res) => {
      this.paymentAmt = res;
      this.changeDetectorRef.detectChanges();
   });
    this.myBookingService.totalAmount.subscribe((res) => {
      this.totalAmt = res;
      this.changeDetectorRef.detectChanges();
    });
    this.myBookingService.openSnackBar.subscribe((res) => {
      this.showSnackbar = res;
      this.changeDetectorRef.detectChanges();
    });
    this.myBookingService.razorpay_payment_id.subscribe((res) => {
      this.razorpay_payment_id = res;
      this.changeDetectorRef.detectChanges();
    }
    );

  }

  checkPayButtonVisibility() {

    if (this.config['Payment Amount']) {
      if (this.miscelleneousConfig['showpaybuttonforpendingpayments'] === 'true') {
        if (this.bookings[0].payer && this.bookings[0].payer.emplGuid === this.authService.user.employeeGuid) {
          if (this.bookings[0].paymentType === 'Bill To User' && this.bookings[0].paymentStatus === 'PENDING') {
            return true;
          }
        }
      }
      if (this.miscelleneousConfig['showpaybuttonforfailedpayments'] === 'true') {
        if (this.bookings[0].payer && this.bookings[0].payer.emplGuid === this.authService.user.employeeGuid) {
          if (this.bookings[0].paymentType === 'Bill To User' && this.bookings[0].paymentStatus === 'FAILED') {
            return true;
          }
        }
      } else {
        if (this.bookings[0].paymentType === 'Bill To User' &&
          (this.bookings[0].paymentStatus === 'PENDING' || this.bookings[0].paymentStatus === 'FAILED')) {
          return true;
        }
      }
    }
    return false;
  }
  getBookingTime(booking: any) {
    if (booking.startTime) {
      const dateMoment = this.utilService.getMoment(booking.startTime);
      return this.miscelleneousConfig['12hrTimeFormat'] === 'true' ?
        dateMoment.format('hh:mm A') : dateMoment.format('HH:mm');
    }
    return '';
  }

  setupConfig() {
    this.commonService.fetchConfig().subscribe((response) => {
      const bookingsConfig = this.commonService.getConfigForElementKey(response, 'Booking Card Section').elementConfigList;
      this.bookingConfigForPage = bookingsConfig;
      for (const field of bookingsConfig) {
        this.config[field.elementKey] = field.config.visibility.visible;
      }
    });
  }
  getConfigForElement(key) {
    return this.getConfigForElementKey(this.bookingConfigForPage, key).config.displayName;
  }

  viewDocument(booking: any) {
    let invoiceStatus;
    if (booking.payer &&
      booking.payer.emplGuid === this.authService.user.employeeGuid) {
      invoiceStatus = booking.riderInvoiceApprovalStatus;
    }
    const navigationExtras: NavigationExtras = {
      state: {
        invoiceStatus,
        isRider: true,
        vendorBillAmount: booking.vendorBillAmount,
        paymentAmount: booking.paymentAmount
      },
      queryParams: { bookingId: booking.bookingId }
    };
    this.router.navigate(['/invoicing/viewDocument'], navigationExtras);
  }

  handleShowBookingDetails() {
    if (this.showBookingsCallback) {
      this.showBookingsCallback.emit({ id: this.bookings[0].bookingId });
    }
  }

  handleShowRequestDetails() {
    if (this.showRequestDetailsCallback) {
      this.showRequestDetailsCallback.emit({ id: this.bookings[0].requestId });
    }
  }

  handleEditBooking(booking: any) {
    this.isBookingEditDisabled(booking);
    if (this.canEdit) {
      this.router.navigate(['/bookings/edit'], { queryParams: { bookingId: booking.bookingId } });
    } else {
      this.drawerRef.close();
      this.showEditBookingError = true;
    }
  }

  handleDuplicateBooking(booking: any) {
    this.router.navigate(['/bookings/create'], { queryParams: { bookingId: booking.bookingId } });
  }

  handleCancelBooking(booking: any) {
    this.drawerRef.close();
    this.isBookingCancelDisabled(booking);
    if (this.canCancel) {
      if (this.cancelBookingCallback) {
        this.cancelBookingCallback.emit({ id: booking.bookingId });
      }
    } else {
      this.showCancelBookingError = true;
    }
  }

  hideCancelBookingError() {
    this.showCancelBookingError = false;
  }

  hideEditBookingError() {
    this.showEditBookingError = false;
  }

  // checkIfBookingCancelled() {
  //   if (this.bookings[0].bookingStatus === 'CANCELLED') {
  //     this.disableAllActions = true;
  //   }
  // }

  isBookingCancelDisabled(booking) {
    let isActive = false;
    let isABooker = false;
    let isARider = false;
    let isValidTime = false;
    let isWithinCutoff = false;

    if (booking.bookingStatus !== 'CANCELLED') {
      isActive = true;
    }

    // check for emplguid
    if (booking.booker.emplGuid === this.authService.user.employeeGuid) {
      isABooker = true;
    } else if (this.ridersList.length) {
      if (this.ridersList.length === 1 && this.ridersList[0].emplGuid === this.authService.user.employeeGuid) {
        isARider = true;
      }
    }

    // check date-time cutoffs
    if (this.utilService.checkIfDateTimeBetween(this.cancelCutOffDetails.start, this.cancelCutOffDetails.end)) {
      isValidTime = true;
    }

    const timeDiff = this.utilService.findTimeDiffInMinutes(booking.startTime);

    if (timeDiff > this.cancelCutOffDetails.cutOffMins) {
      isWithinCutoff = true;
    }

    this.canCancel = isActive && isValidTime && isWithinCutoff && (isABooker || isARider);
    return !this.canCancel;
  }

  isBookingEditDisabled(booking) {
    let isActive = false;
    let isABooker = false;
    let isARider = false;
    let isValidTime = false;
    let isWithinCutoff = false;

    if (booking.bookingStatus !== 'CANCELLED') {
      isActive = true;
    }

    // check emplguid
    if (booking.booker.emplGuid === this.authService.user.employeeGuid) {
      isABooker = true;
    } else if (this.ridersList.length) {
      for (const rider of this.ridersList) {
        if (rider.emplGuid === this.authService.user.employeeGuid) {
          isARider = true;
          break;
        }
      }
    }

    // check date-time cutoffs
    if (this.utilService.checkIfDateTimeBetween(this.editCutOffDetails.start, this.editCutOffDetails.end)) {
      isValidTime = true;
    }

    const timeDiff = this.utilService.findTimeDiffInMinutes(booking.startTime);

    if (timeDiff > this.editCutOffDetails.cutOffMins) {
      isWithinCutoff = true;
    }

    this.canEdit = isActive && isValidTime && isWithinCutoff && (isABooker || isARider);
    return !this.canEdit;
  }

  handleShowHistoryView(booking: any) {
    if (this.showHistoryCallback) {
      this.showHistoryCallback.emit({ id: booking.bookingId });
    }
  }

  toggleTracking() {
    this.isTrackingVisible = !this.isTrackingVisible;
  }

  paymentSuccess(msg: any) {
    this.bookings[0]['paymentStatus'] = "PROCESSING";
    this.showSuccessMessage = true;
    this.changeDetectorRef.detectChanges();

  }

  paymentFailed(message: string) {
    this.showPaymentFailed = true;
    this.paymentFailedMessage = message;
    this.changeDetectorRef.detectChanges();
     }

  hidePaymentError() {
    this.showPaymentFailed = false;
    this.paymentFailedMessage = '';
    this.changeDetectorRef.detectChanges();
    }

  toggleToast() {
    this.showSuccessMessage = false;
    this.message = "";
    this.changeDetectorRef.detectChanges();
  }
  closeBackground() {
    this.hasDimmBack = false;
  }


  openDrawer(booking: any) {
    this.drawerRef = this.drawerSvc.show(
      BookingDetailsSidebarComponent,
      {
        data: booking,
        miscelleneousConfig: this.miscelleneousConfig,
        tab: this.tabValue,
        isEditDisabled: this.isBookingEditDisabled(booking),
        isCancelDisabled: this.isBookingCancelDisabled(booking),
        method: (action) => {
          switch (action) {
            case 'edit':
              this.handleEditBooking(booking);
              break;
            case 'duplicate':
              this.handleDuplicateBooking(booking);
              break;
            case 'document':
              this.viewDocument(booking);
              break;
            case 'history':
              this.handleShowHistoryView(booking);
              break;
            case 'cancel':
              this.handleCancelBooking(booking);
              break;
            case 'track': {
              this.drawerRef.close();
              this.isTrackingVisible = true;
            }
                          break;
            case 'upload':
              this.handleEditBooking(booking);
              break;
            default:
          }
        }
      },
      { width: "422px" }
    );
    // 3rd optional argument options = {
    //    width?: string | default: "422px",
    //    height?: string| default: 100vh,
    // }
    // drawerRef.expand() expands drawer to 100vw
    // drawerRef.collapse() collapses drawer to default 422px
    // drawerRef.close() closes drawer
    // drawerRef.isExpanded to check if drawer is expanded to 100vw
    // drawerRef.overlay.updateSize({ width: "300px" }); to change width of drawer
    // drawerRef.overlay to get access to cdk overlay ref
  }
  openPaymentDrawer(booking: any) {
    this.drawerRef = this.drawerSvc.show(
      PaymentCartComponent,
      {
        data: booking,
        miscelleneousConfig: this.miscelleneousConfig,
      }
    );
  }

  openTracking() {
    this.isTrackingVisible = true;
  }
  viewMore() {
    // this.upcomingOnly = true;
    this.showPaginationCallback.emit(true);
    // this.filteredBookings = this.bookings;
  }
  goBack() {
    // this.upcomingOnly = false;
    // this.bookingLabel = "Upcoming Booking";
    this.showPaginationCallback.emit(false);
    // this.filteredBookings = this.bookings.slice(1,4);
  }

  getBookingDate(date: string) {
    const dateString = parseZone(date, 'DD/MM/YYYY').format();
    return this.datePipe.transform(dateString, 'EEE, MMM dd');
  }
  closePaymentPopup(){

    this.showBulkPaymentPopup = false;
    this.myBookingService.singlePaymentPopup.next(false);
    this.refreshBookings.emit(true);
    this.changeDetectorRef.detectChanges();

  }

  getMiliseconds(book): number{
    const dateParts = book.startTime.split(' ')[0].split('/');
    const timeParts =  book.startTime.split(' ')[1].split('/');
    const formattedDate = `${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`;
    const formattedTime = `${timeParts[0]}:${timeParts[1]}:${timeParts[2]}`;
    const milliseconds = new Date(`${formattedDate} ${formattedTime}`).getTime();

    return milliseconds;
  }
  checkIfMarshalAssigned(booking){
    booking.stops.forEach(stop => {
      stop.riders.forEach(rider => {
        rider.riderType === 'MARSHAL' ? this.marshalAssigned = true : this.marshalAssigned = false;
      });
    });
    return this.marshalAssigned == true ? 'assets/MarshallStatus-Assigned.svg' : 'assets/marshalNotAssigned.svg';
  }

  checkManagerStatus(managerStatus: any) {
    if (managerStatus === 'APPROVED')
    {
      this.managerStatus = {
        managerState: managerStatus,
        text: "Booking approved by your manager.",
        color: '#0B547D'
      };
    }
    else if (managerStatus === 'PENDING')
    {
      this.managerStatus = {
        managerState: 'IN REVIEW',
        text: "Sent to manager for approval",
        color: '#E65010'
      };
    }
    else if (managerStatus === 'REJECTED')
    {
      this.managerStatus = {
        managerState: 'REJECTED',
        text: "Manager rejected your booking",
        color: '#B00020'
      };
    }
    else{
      this.managerStatus = {
        managerState: null,
        text: 'This booking does not require manager approval',
        color: ''
      };
    }
  }
  checkOtherState(booking: any)
  {
    // bookingStatus  cabAllocStatus  managerStatus CANCELLED

    if (booking.bookingStatus === 'CANCELLED')
    {
      this.otherState = {
        text: booking.bookingStatus,
        color: '#B00020',
        backGround: '#F8E8E6',
        url: 'assets/bookingCancelled.svg'
      };
    }
    else if (booking.cabAllocStatus === 'FINALIZED')
    {
      this.otherState = {
        text: 'Cab Allocated',
        color: '#035F6B',
        backGround: '#ECF5EA',
        url: 'assets/managerBookingApprove.svg'
      };
    }
    else if (booking.managerStatus === 'APPROVED')
    {
      this.otherState = {
        text: 'Booking Approved',
        color: '#035F6B',
        backGround: '#ECF5EA',
        url: 'assets/bookingApprovedState.svg'
      };
    }
    else if (booking.bookingStatus === 'ACTIVE')
    {
      this.otherState = {
        text: 'Booking Planned',
        color: '#0937B2',
        backGround: '#E1F5F8',
        url: 'assets/bookingPlannedState.svg'
      };
    }

  }
  ngOnDestroy(): void {
     if (this.drawerRef) {
      this.drawerRef.close();
    }
  }
}
